<template>
    <el-container style="padding: 10px;overflow: auto;height: 100%;" class="visit">
        <el-header style="background-color: white;text-align: center">
            <h2>花田悦舍体验官调查表</h2>
        </el-header>
        <el-main style="background-color: white;">
            <div style="font-size: 12px">
                尊敬的体验官你好！
            </div>
            <div style="font-size: 12px">
                我们很在乎服务品质调研，
            </div>
            <div style="font-size: 12px">
                也请您认真填写以下内容，感恩有你
            </div>
            <el-divider></el-divider>
            <el-form label-width="120px" label-position="left"  :model="addVisit" :rules="rules" ref="form1">
                <el-form-item label="姓名" prop="visitname">
                    <el-input type="input" v-model.trim="addVisit.visitname" readonly></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="memberphone">
                    <el-input type="input" v-model.trim="addVisit.memberphone" readonly></el-input>
                </el-form-item>
                <el-form-item label="日期" prop="visitdate">
                    <el-input type="input" v-model.trim="addVisit.visitdate" readonly></el-input>
                </el-form-item>
                <el-form-item label="门店地址" prop="storename" class="address">
                    <el-input type="input" v-model.trim="addVisit.storename" readonly></el-input>
                </el-form-item>
                <el-form-item label="体验项目" prop="projectname">
                    <el-input type="input" v-model.trim="addVisit.projectname" readonly></el-input>
                </el-form-item>
            </el-form>
            <el-form label-position="top" :model="addVisit"  :rules="rules" ref="form">
                <el-form-item label="1.服务是否微笑热情(前台接待/美疗师/美容老师)" prop="v01" required>
                    <el-radio-group v-model="addVisit.v01" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="2.上茶礼，换鞋礼，是否及时，是否单腿下蹲?" prop="v02" required>
                    <el-radio-group v-model="addVisit.v02" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="3.门店整体卫生是否干净,物品排列整齐?" prop="v03" required>
                    <el-radio-group v-model="addVisit.v03" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="4.护理前是否有咨询，检测?" prop="v04" required>
                    <el-radio-group v-model="addVisit.v04" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="5.是否有参观门店和美容房间内的介绍?" prop="v05" required>
                    <el-radio-group v-model="addVisit.v05" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="6.服务人员是否着装整洁，佩戴口罩及工牌?" prop="v06" required>
                    <el-radio-group v-model="addVisit.v06" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="7.护理前是否报时，服务时间长是否足够?" prop="v07" required>
                    <el-radio-group v-model="addVisit.v07" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="8.美容师的操作手法是否满意?(稳，准，舒服)" prop="v08" required>
                    <el-radio-group v-model="addVisit.v08" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="9.服务过程中美容师是否有离开房间?" prop="v09" required>
                    <el-radio-group v-model="addVisit.v09" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="10.是否存在强推销售行为?" prop="v10" required>
                    <el-radio-group v-model="addVisit.v10" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="11.护理结束后门店是否有做满意度调查表?" prop="v11" required>
                    <el-radio-group v-model="addVisit.v11" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0"  style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="12.离店时美容师是否有送达到大门口?" prop="v12" required>
                    <el-radio-group v-model="addVisit.v12" :disabled="issave">
                        <el-radio :label="1"  style="width: 40%">是</el-radio>
                        <el-radio :label="0" style="width: 40%">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="13.请根据您的整体体验，为本次暗访打总分?" prop="totalscore" required>
                    <el-rate v-model="addVisit.totalscore" :max="10" :disabled="issave" :show-score="true" @input="totalScore">
                    </el-rate>
                </el-form-item>
                <el-form-item label="14.您认为马上需要改进的是?" prop="nowimprove">
                    <el-input type="textarea" v-model="addVisit.nowimprove" :readonly="issave" :autosize="{minRows: 2, maxRows: 100}"></el-input>
                </el-form-item>
                <el-form-item label="15.您认为哪些可以做的更好?" prop="afterimprove">
                    <el-input type="textarea" v-model="addVisit.afterimprove" :readonly="issave" :autosize="{minRows: 2, maxRows: 100}"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="width: 100%" @click="saveVisit" :loading="isLoading" v-if="issave==false">提交</el-button>
                </el-form-item>
            </el-form>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            issave:false,
            isLoading:false,
            rules: {
                v01:[
                    {required: true, message: "请选择服务是否微笑热情(前台接待/美疗师/美容老师)", trigger: 'blur'}
                ],
                v02:[
                    {required: true, message: "请选择上茶礼，换鞋礼，是否及时，是否单腿下蹲?", trigger: 'blur'}
                ],
                v03:[
                    {required: true, message: "请选择门店整体卫生是否干净,物品排列整齐?", trigger: 'blur'}
                ],
                v04:[
                    {required: true, message: "护理前是否有咨询，检测?", trigger: 'blur'}
                ],
                v05:[
                    {required: true, message: "请选择是否有参观门店和美容房间内的介绍?", trigger: 'blur'}
                ],
                v06:[
                    {required: true, message: "请选择服务人员是否着装整洁，佩戴口罩及工牌?", trigger: 'blur'}
                ],
                v07:[
                    {required: true, message: "请选择护理前是否报时，服务时间长是否足够?", trigger: 'blur'}
                ],
                v08:[
                    {required: true, message: "请选择美容师的操作手法是否满意?(稳，准，舒服)", trigger: 'blur'}
                ],
                v09:[
                    {required: true, message: "请选择服务过程中美容师是否有离开房间?", trigger: 'blur'}
                ],
                v10:[
                    {required: true, message: "请选择是否存在强推销售行为?", trigger: 'blur'}
                ],
                v11:[
                    {required: true, message: "请选择护理结束后门店是否有做满意度调查表?", trigger: 'blur'}
                ],
                v12:[
                    {required: true, message: "请选择离店时美容师是否有送达到大门口?", trigger: 'blur'}
                ],
                totalscore:[
                    {min: 1,message:"请选择本次暗访打总分",trigger:'change',type:'number'}
                ]
            },
            storeData:[],
            addVisit:{

            },
            visit:{
                visitname:"",
                storeid:"",
                storename:"",
                sysbillid:"",
                projectname:"",
                memberphone:"",
                visitdate:"",
                v01:"",
                v02:"",
                v03:"",
                v04:"",
                v05:"",
                v06:"",
                v07:"",
                v08:"",
                v09:"",
                v10:"",
                v11:"",
                v12:"",
                totalscore:0,
                nowimprove:"",
                afterimprove:"",
            }
        }
    },
    created() {
        this.addVisit=this.$copy(this.visit);
        let storeid=this.$getUrlKey("storeid");
        let sysbillid=this.$getUrlKey("sysbillid");
        let visitname=this.$getUrlKey("visitname");
        let storename=this.$getUrlKey("storename");
        let memberphone=this.$getUrlKey("memberphone");
        let visitdate=this.$getUrlKey("visitdate");
        let projectname=this.$getUrlKey("projectname");
        this.addVisit.sysbillid=sysbillid;
        this.addVisit.storeid=storeid;
        this.addVisit.visitname=visitname;
        this.addVisit.storename=storename;
        this.addVisit.memberphone=memberphone;
        this.addVisit.visitdate=visitdate;
        this.addVisit.projectname=projectname;
        this.getToken();
    },
    methods:{
        getVisitById(){
            this.$post('returnvisit/getVisitById',{sysbillid: this.addVisit.sysbillid}).then(res=>{
                if(res.sucess){
                    if(res.object!=null){
                        this.addVisit=res.object;
                        console.log(this.addVisit);
                        if(this.addVisit.iwrite==1){
                            this.issave=true;
                        }
                    }
                }
                else{
                    this.$message.error(res.message);
                }
            });
        },
        totalScore(val){
            /*console.log(val);
            if(this.$refs["form"]) {
                this.$refs["form"].validate((valid)=>{});
            }*/
        },
        saveVisit(){
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    this.$refs["form1"].validate((valid) => {
                        if (valid) {
                            this.isLoading = true;
                            this.$postw("returnvisit/updateVisit",this.addVisit).then(res=>{
                                this.isLoading = false;
                                if (res.sucess) {
                                    this.$router.push({
                                        path: "/visitsucess"
                                    });
                                } else {
                                    this.$message.error(res.message);
                                }
                            });
                        }
                    });
                }
            });
        },
        getToken(){
            this.$post('wechat/getToken').then(res=>{
                if (res.sucess) {
                    localStorage.setItem("token",res.object);
                    this.getVisitById();
                }
                else {
                    this.$alert(res.message, '提示');
                }
            });
        },

    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
    .visit .el-radio-group{
        width: 100%;
    }

    .el-select-dropdown__item{
        font-size: 12px;
        padding:0 20px;
    }
</style>



// WEBPACK FOOTER //
// src/page/check/visitcust.vue